import * as rules from '../../../../shared/src/rules/progress';
import { content, type QuestObjective } from '../content';
export * from '../../../../shared/src/rules/progress';
export const allQuests = () => rules.allQuests(content());
export const questsGivenBy = (npc: number) => rules.questsGivenBy(npc, content());
export const describeTask = (o: QuestObjective) => rules.describeTask(o, content());
export const describeObjective = (o: QuestObjective) => rules.describeObjective(o, content());
